import React from "react";
import "./second-banner.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import config from "../../config";
export default function SecondBanner() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });

  return (
    <section
      className={`second-banner-section ${
        isVisible ? "section-animation" : ""
      }`}
      ref={ref}
    >
      <div className="container">
        <div className="second-banner-section-wrapper">
          <div className="second-banner-section-heading">
            <h2>Stay Secure, Stay Compliant </h2>
            <p>
              Empower your AI with proactive threat detection and seamless
              security integration.
            </p>
            <div className="second-banner-button-wrapper">
              <a href={config.bookdemo.Link}>
                <button className="banner-button">
                  <p>Book Demo</p>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
